import axios from 'axios';


// 'http://localhost:8000'
// 'https://softwareprojects.uz'
// 'https://pa.uz'

const BASE_URL = process.env.REACT_APP_API_URL || 'https://softwareprojects.uz';
const cleanBaseUrl = BASE_URL.replace(/\/+$/, '');

const storageBaseUrl = cleanBaseUrl.replace(/\/api$/, '');

const apiClient = axios.create({
    baseURL: cleanBaseUrl,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

export const sendFrontAction = async (action, data = {}, method = 'POST') => {
    const currentMethod = method.toUpperCase();

    const requestConfig = {
        method: currentMethod,
        url: `/front/${action}`, // 👈 маршрут зарегистрирован в routes/api.php → префикс /api обязателен
        [currentMethod === 'GET' ? 'params' : 'data']: data
    };

    // const requestConfig = {
    //     method: currentMethod,
    //     url: `/api/front/${action}`, // 👈 маршрут зарегистрирован в routes/api.php → префикс /api обязателен
    //     [currentMethod === 'GET' ? 'params' : 'data']: data
    // };

    try {
        const response = await apiClient(requestConfig);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw new Error('Не удалось установить безопасное соединение с сервером');
    }
};

// 👇 Единая точка для получения адреса файлов (изображения, PDF) с бэкенда.
// Раньше этот же URL был захардкожен отдельно в CarCard, CarDetail, TestDriveAppointment и т.д.
export const getBackendFileUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${storageBaseUrl}/storage${cleanPath}`;
};

export default apiClient;